import type { BusinessListing } from '@/types/business';

export const SAMPLE_BUSINESSES: BusinessListing[] = [
  {
    id: 'b1',
    ownerId: 'u10',
    name: 'The Walled Kitchen Garden',
    slug: 'the-walled-kitchen-garden',
    status: 'approved' as const,
    contentType: 'business',
    coverageType: 'region' as const,
    categories: ['nursery', 'gardening-school'],
    tagline: 'Heritage vegetable plants, seeds & growing courses in the heart of the Cotswolds',
    description: 'We grow over 400 varieties of heritage and unusual vegetable plants for sale from our walled kitchen garden. Our growing courses cover everything from basic vegetable growing to advanced biodynamic practice.',
    website: 'https://example.com',
    geographicArea: 'Cotswolds, Gloucestershire, Oxfordshire',
    country: 'United Kingdom',
    services: ['Heritage plant sales', 'Seed sales', 'One-day growing courses', 'Garden consultation'],
    organicCertified: true,
    certificationBody: 'Soil Association',
    reviews: [
      {
        id: 'r1',
        businessId: 'b1',
        userId: 'u5',
        userName: 'Margaret H.',
        rating: 5,
        title: 'An absolute treasure',
        body: 'Discovered this place by accident and have been returning every year. The range of heritage tomatoes alone is worth the trip. Lovely people, beautiful setting.',
        createdAt: '2025-06-15',
        verified: true,
      },
      {
        id: 'r2',
        businessId: 'b1',
        userId: 'u8',
        userName: 'James T.',
        rating: 5,
        title: 'Best growing course I\'ve attended',
        body: 'The biodynamic day course was genuinely transformative. Well-structured, hands-on, and the tutors clearly know their stuff from years of real practice.',
        createdAt: '2025-08-03',
        verified: true,
      },
    ],
    averageRating: 5,
    reviewCount: 2,
    featured: true,
    verified: true,
    createdAt: '2024-01-15',
    updatedAt: '2025-09-01',
  },
  {
    id: 'b2',
    ownerId: 'u11',
    name: 'Growing Roots',
    slug: 'growing-roots',
    status: 'approved' as const,
    contentType: 'vlog',
    categories: ['vlog', 'market-garden'],
    tagline: 'A family\'s journey converting a field into a biodynamic market garden — filmed as it happens',
    description: 'We document our conversion of 2 acres in West Wales from rough pasture to a certified biodynamic market garden. No sugar-coating — the failures are as instructive as the successes.',
    website: 'https://example.com/growingroots',
    socialLinks: { youtube: '@growingroots', instagram: '@growingroots' },
    geographicArea: 'West Wales, UK (content relevant globally)',
    country: 'United Kingdom',
    services: ['Weekly video content', 'Q&A community', 'Online growing course (coming soon)'],
    organicCertified: false,
    latestPostTitle: 'Our first biodynamic spray day — what we learned',
    latestPostDate: '2026-03-08',
    reviews: [
      {
        id: 'r3',
        businessId: 'b2',
        userId: 'u12',
        userName: 'Sarah K.',
        rating: 5,
        title: 'Genuine and inspiring',
        body: 'The honesty about what goes wrong is what sets this channel apart. Most growing content shows only success — this shows the reality and it\'s far more useful.',
        createdAt: '2026-02-14',
        verified: true,
      },
    ],
    averageRating: 5,
    reviewCount: 1,
    featured: true,
    verified: true,
    createdAt: '2025-03-01',
    updatedAt: '2026-03-08',
  },
  {
    id: 'b3',
    ownerId: 'u13',
    name: 'Soil & Soul',
    slug: 'soil-and-soul',
    status: 'approved' as const,
    contentType: 'blog',
    categories: ['blog', 'consultancy'],
    tagline: 'Practical organic growing advice grounded in ecology and thirty years\' experience',
    description: 'A blog by experienced market gardener and soil scientist Dr. Helen Marsh. Detailed, evidence-based articles on soil science, composting, crop rotation, and ecological growing methods.',
    website: 'https://example.com/soilandsoul',
    socialLinks: { instagram: '@soilandsoulblog' },
    geographicArea: 'UK (content relevant globally)',
    country: 'United Kingdom',
    services: ['Weekly blog posts', 'Online consultancy', 'Soil analysis interpretation'],
    organicCertified: false,
    latestPostTitle: 'The science behind companion planting: what evidence actually supports',
    latestPostDate: '2026-03-10',
    reviews: [
      {
        id: 'r4',
        businessId: 'b3',
        userId: 'u14',
        userName: 'Peter M.',
        rating: 5,
        title: 'The best growing blog on the internet',
        body: 'Helen brings proper scientific rigour to biodynamic and organic claims — she\'ll tell you honestly what the evidence shows and what is more belief-based. Invaluable.',
        createdAt: '2025-11-20',
        verified: true,
      },
    ],
    averageRating: 5,
    reviewCount: 1,
    featured: false,
    verified: true,
    createdAt: '2024-06-01',
    updatedAt: '2026-03-10',
  },
];
